import styled, { css } from "styled-components";
import theme from "theme";
import { WithThemeProp } from "utils";
import Text from "../Text";
import { StyledProps } from "./types";

const getAvatarSize = ({ size }: StyledProps & WithThemeProp) => {
    const { sizes, defaults } = theme.avatar;
    return sizes[size || defaults.size].avatarSize;
};

const getShadowColor = ({
    hoverTextShadowColor,
    hoverImgShadowColor,
    isImage,
}: StyledProps & WithThemeProp) => {
    const { defaults } = theme.avatar;
    return isImage
        ? hoverImgShadowColor || defaults.hover.imgShadowColor
        : hoverTextShadowColor || defaults.hover.textShadowColor;
};

const hoverStyle = ({
    hoverBgColor,
    hoverTextColor,
}: StyledProps & WithThemeProp) => {
    const { defaults } = theme.avatar;
    return css`
        &:hover {
            background: ${hoverBgColor || defaults.hover.bgColor};
            box-shadow: 0 0.4rem 0.8rem ${getShadowColor};
            ${Text.Style} {
                color: ${hoverTextColor || defaults.hover.textColor};
            }
        }
    `;
};

const pressedStyle = ({
    pressedBgColor,
    pressedTextColor,
}: StyledProps & WithThemeProp) => {
    const { defaults } = theme.avatar;
    return css`
        &:active {
            background: ${pressedBgColor || defaults.pressed.bgColor};
            ${Text.Style} {
                color: ${pressedTextColor || defaults.pressed.textColor};
            }
        }
    `;
};

const getTextStyle = (props: StyledProps & WithThemeProp) => {
    const { size, textColor, bgColor } = props,
        { defaults, sizes } = theme.avatar,
        { avatarSize, fontSize } = sizes[size || defaults.size];

    return css`
        color: ${textColor || "#fff"};
        background: ${bgColor || defaults.bgColor};
        user-select: none;
        display: flex;
        justify-content: center;
        align-items: center;
        ${Text.Style} {
            line-height: ${avatarSize};
            font-size: ${fontSize};
            font-weight: ${theme.font.weights[defaults.fontWeight]};
            font-family: ${defaults.fontFamily};
        }
    `;
};

export const AvatarStyled = styled("div")<StyledProps>`
    display: inline-block;
    text-align: center;
    min-width: max-content;
    width: ${getAvatarSize};
    height: ${getAvatarSize};
    border-radius: ${() => theme.avatar.defaults.borderRadius};
    overflow: hidden;
    cursor: ${({ onClick, disabled }) =>
        disabled ? "not-allowed" : onClick ? "pointer" : "inherit"};
    ${getTextStyle}
    img {
        width: ${getAvatarSize};
        height: ${getAvatarSize};
        object-fit: cover;
        border: 0.1rem solid ${() => theme.avatar.defaults.borderColor};
        box-sizing: border-box;
        border-radius: ${() => theme.avatar.defaults.borderRadius};
    }
    ${(props) => props.onClick && hoverStyle};
    ${(props) => props.onClick && pressedStyle};
`;
